import { type ComputedRef, ref } from "vue";

const crmProviderTypes = ["hubspot", "salesforce", "zoho", "pipedrive", "microsoft_dynamics"] as const;
const crmProviderNames = ["Hubspot", "Salesforce", "Zoho", "Pipedrive", "Microsoft Dynamics"] as const;
// const crmProviderLogos = [HubspotLogo, SalesforceLogo, ZohoLogo, PipedriveLogo] as const;

type ICRMProviderType = (typeof crmProviderTypes)[number];

interface ICRMProvider {
	connected: ComputedRef<boolean>;
	disconnecting: ComputedRef<boolean>;
}

const crmProviders = ref<Record<ICRMProviderType, ICRMProvider>>({} as any);

export { crmProviderTypes, crmProviderNames, type ICRMProviderType, type ICRMProvider, crmProviders };
